import { NGET, NPOST } from '@/utils/net-work'
import axios from 'axios'
const baseUri = '/api'

// 渲染图表
function statisticsDetail(params: any) {
  return NPOST(baseUri + '/statistics/dashboard/detail', params)
}

export {
  statisticsDetail
}
